webpackJsonp([1],{

/***/ 2475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bowser = __webpack_require__(60);

var _bowser2 = _interopRequireDefault(_bowser);

var _config = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidUserBrowser = _bowser2.default.check(_config.CONFIG.LIBRARIES.SUPPORTED_BROWSERS);

if (!isValidUserBrowser) {
    window.open('browsers.html', '_self');
}

/***/ })

},[2475]);


// WEBPACK FOOTER //
// browsers.a7f7daae34fe8dd3240e.js